import { render, staticRenderFns } from "./UserFavouriteStores.vue?vue&type=template&id=759021ec&scoped=true"
import script from "./UserFavouriteStores.vue?vue&type=script&lang=js"
export * from "./UserFavouriteStores.vue?vue&type=script&lang=js"
import style0 from "./UserFavouriteStores.vue?vue&type=style&index=0&id=759021ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759021ec",
  null
  
)

export default component.exports